class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.isCartPage = document.getElementById("main-cart-wrapper");

        //this.setInitialItemCountAndEmptyStatus();
        this.setupElements();
        this.setupListeners();
    }

    enableLoading(line) {
        document.getElementById('cart-drawer-items-main').classList.add('cart__items--disabled')
        this.querySelectorAll(`#MainCartDraweritem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'))
        document.activeElement.blur()
        this.lineItemStatusElement.setAttribute('aria-hidden', false)
    }

    setInitialItemCountAndEmptyStatus() {

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce((total, quantityInput) => {
            return total + parseInt(quantityInput.value);
        }, 0);

        this.cartIsEmpty = !!!this.currentItemCount;
    }

    setupElements() {
        this.cartDrawerHeader = this.querySelector(".cart-drawer-header h3");
            this.cartAccessibleMessage = this.querySelector(".cart-drawer-title__cart-accessible-message")
        this.lineItemStatusElement = document.getElementById(
            "cart-drawer-line-item-status"
        );
        this.drawerOverlay = document.getElementById("cart-drawer-overlay");
        this.cartDrawerCloseBtn = document.getElementById(
            "CartDrawerDrawerClose"
        );
        this.cartBubble = document.getElementById("cart-icon-bubble");
        this.cartSection = document.getElementById("shopify-section-cart-drawer");
        if (this.cartSection) this.cartSection.style.display = "none";
    }

    updateQuantity(line, quantity, name, recipe, element) {

        this.enableLoading(line);

        let allSubItems = document.querySelectorAll("[data-productkey]");
        let relevantItems = [];

        //these are items that only increase by 1
        let increaseTheseOnce = ["MCS Setup Fees", "1 Color Print Set Up", "1 Color RE-Set Up", "2 Color Print Set Up", "2 Color RE-Set Up", "Multicolor Print Set Up", "Multicolor RE-Set Up", "Laser Etch Set Up", "Laser Etch RE-Set Up"];

        allSubItems.forEach( (individualItem) => {
            
            var subItemProductKey = individualItem.dataset.productkey;
            
            if(individualItem.dataset.recipe && individualItem.dataset.recipe === recipe) {
                relevantItems.push({key: subItemProductKey, title: individualItem.dataset.producttitle});
            }

        });

        console.log("these are the relevant items: ", relevantItems);

        const body = JSON.stringify({
            line,
            quantity,
            sections: ['main-cart-form'], // only request this section, optimized
            sections_url: window.location.pathname
        });

        var hitURL;

        if(recipe) {
            hitURL = spectrumBuildUpdate(relevantItems, element.value, increaseTheseOnce);
        }

        if(!recipe) {
            relevantItems.push({key: element.dataset.key});
            hitURL = spectrumBuildUpdate(relevantItems, element.value, increaseTheseOnce);
        }

        fetch(hitURL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
        }).then((response) => {
            return response.text()
        })
        .then((state) => {
            this.updateCartDisplay();
        }).catch((e) => {

            if(this.querySelectorAll(".loading-overlay")) {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
            }
        
            //document.getElementById('cart-errors').textContent = window.cartStrings.error
            this.disableLoading()
        })
    }

    setupListeners() {
        this.addEventListener(
            "change",
            debounce((event) => {
                if (event.target.getAttribute("id") == "CartDrawer-note")
                    return;

                this.updateQuantity(
                    event.target.dataset.index,
                    event.target.value,
                    document.activeElement.getAttribute('name'), 
                    event.target.dataset.recipe, 
                    event.target
                );
            }, 100)
        );

        this.cartDrawerCloseBtn.addEventListener("click", () => this.close());
        this.drawerOverlay.addEventListener("click", () => this.close());
        this.cartBubble.addEventListener("click", () => this.open());
        this.setCloseListeners();
    }

    setCloseListeners() {
        document.addEventListener("keyup", (e) => {
            if (e.code == "Escape") this.close();
        });
    }

    open(accessibleMessage) {
        this.cartSection.style.display = "block"

        this.drawerOverlay.classList.replace("closed", "open");
        this.classList.replace("closed", "open");

        this.cartDrawerHeader.focus();

        this.updateCartMessage(accessibleMessage)
    }

    reinitializeSectionScripts(sectionId) {
        const section = document.querySelector(sectionId);
        if (!section) return;

        const scripts = Array.from(section.querySelectorAll("script"));

        scripts.forEach((oldScript) => {
            const newScript = document.createElement("script");

            Array.from(oldScript.attributes).forEach((attr) =>
                newScript.setAttribute(attr.name, attr.value)
            );

            newScript.textContent = oldScript.textContent;

            oldScript.replaceWith(newScript);
        });
    }

    updateCartMessage(accessibleMessage) {
        if (!this.cartAccessibleMessage) return;

        if (!accessibleMessage) {
            this.cartAccessibleMessage.removeAttribute('aria-label')
            this.cartAccessibleMessage.innerHTML = ''
            return;
        }
        this.cartAccessibleMessage.setAttribute('aria-label', accessibleMessage)
        this.cartAccessibleMessage.innerHTML = accessibleMessage
    }

    close() {
        this.classList.replace("open", "closed");
        this.drawerOverlay.classList.replace("open", "closed");

        this.cartSection.style.display = "none"
    }

    getSectionInnerHTML(html, selector) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : "";
    }

        getSectionsToRender() {
        let sections = [
            {
                id: "cart-drawer",
                shopifyfile: "cart-drawer",
                selector: ".cart-drawer-items",
                cartPageReserved: false,
            },
            {
                id: "cart-drawer-footer-main",
                shopifyfile: "cart-drawer",
                selector: "#cart-drawer-footer-main .js-contents",
                cartPageReserved: false,
            },
            /*{
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
                cartPageReserved: false,
            },
            {
                id: "cart-drawer-shipping-indicator",
                section: "main-cart-form",
                selector: "#cart-drawer-shipping-indicator",
                cartPageReserved: false,
            },
            {
                id: "cart-drawer-footer-main",
                section: "main-cart-footer",
                selector: ".js-contents",
                cartPageReserved: false,
            },
            {
                id: "main-cart-items",
                section: "main-cart-form",
                selector: ".js-contents",
                cartPageReserved: true,
            },
            {
                id: "main-cart-footer",
                section: "main-cart-footer",
                selector: ".js-contents",
                cartPageReserved: true,
            },
            {
                id: "shopify-section-shipping-indicator",
                section: "shipping-indicator",
                selector: ".js-contents",
                cartPageReserved: true,
            },*/
        ];

        if (!this.isCartPage) {
            sections = sections.filter((ele) => !ele.cartPageReserved);
        }

        return sections;
    }

    // For updating the display on demand, called by other scripts
    updateCartDisplay() {

    const sections = this.getSectionsToRender();

    const fetchPromises = sections.map(section => {
        const beforeUpdate = document.querySelector(section.selector);

        if (!beforeUpdate) {
        console.warn(`⚠️ No element found for selector: ${section.selector}`);
        return Promise.resolve();
        }

        const url = `${window.location.pathname}?section_id=${section.shopifyfile}`;

        return fetch(url)
        .then(res => res.text())
        .then(html => {

            console.log(`✅ Fetched ${section.shopifyfile}, length:`, html.length);

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newSectionHTML = doc.querySelector(section.selector);

            if (!newSectionHTML) {
            console.warn(`⚠️ Could not find ${section.selector} in fetched HTML`);
            return;
            }

            //console.log("Before update:", beforeUpdate.outerHTML);
            //console.log("After update:", newSectionHTML.outerHTML);

            beforeUpdate.replaceWith(newSectionHTML);

            if (this.reinitializeSectionScripts) {
            console.log("🔁 Reinitializing section scripts:", section.id);
            this.reinitializeSectionScripts(section.id);
            }

            this.updateEmptyCartDrawerState();
            //this.reloadCartPageIfEmpty();
            document.dispatchEvent(new Event("postCartAction"));
        })
        .catch(err => console.error(`❌ Error updating ${section.shopifyfile}:`, err));
    });

    console.groupEnd();
    return Promise.all(fetchPromises);
    }


    renderContents(parsedState, shouldOpen = true) {

        console.log("renderContents: ", parsedState);

        console.log("render these sections: ", this.getSectionsToRender());

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);
            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
    }

    postQuantityDisplayUpdate(state, line, name) {
        const parsedState = JSON.parse(state);

        this.cartIsEmpty = parsedState.item_count === 0;
        this.currentItemCount = parsedState.item_count;

        this.getSectionsToRender().forEach((section) => {
            this.updateDrawerSectionHTMLWithSectionStr(section, parsedState);
            this.updateMainCartSectionHTMLWithSectionStr(section, parsedState);
        });

        this.updateEmptyCartDrawerState();
        this.reloadCartPageIfEmpty();

        document.dispatchEvent(new Event("postCartAction"));
    }

    updateMainCartSectionHTMLWithSectionStr(section, parsedState) {
        if (section.cartPageReserved && this.isCartPage) {
            const sectionElement = document.querySelector(
                "#main-cart-wrapper #" + section.id
            );
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateDrawerSectionHTMLWithSectionStr(section, parsedState) {

        console.log("updateDrawerSectionHTML()", section);
        console.log("section.section: ", section.section);
        console.log("PARSED STATE TEST: ", parsedState);

        if (!section.cartPageReserved) {
            const sectionElement = document.getElementById(section.id);
            const childSection = sectionElement.querySelector(section.selector);
            const fallbackSection = document.getElementById(section.id);
            const elementToReplace = childSection || fallbackSection;

            setInnerHTML(
                elementToReplace,
                this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                )
            );
        }
    }

    updateEmptyCartDrawerState() {

        console.log("updateEmptyCartDrawer()");

        document.querySelector(".cart-drawer-container").classList.remove("is-empty");
        document.getElementById("main-cart-items")?.classList.toggle("is-empty", this.cartIsEmpty);

        //this.classList.toggle("is-empty", this.cartIsEmpty);
    }

    reloadCartPageIfEmpty() {
        let cartItems = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items .js-contents > .main-cart-item"
        );
        let cartPageItemsContainer = document.querySelectorAll(
            "#shopify-section-main-cart-form #main-cart-items"
        );
        if (!cartItems.length && cartPageItemsContainer.length)
            location.reload();
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            document
                .getElementById(`CartDrawerLine-item-error-${line}`)
                .querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    document.getElementById(`CartDrawerQuantity-${line}`).value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
        const cartStatus = document.getElementById(
            "cart-drawer-live-region-text"
        );
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }
}

customElements.define("cart-drawer", CartDrawer);

function updateShoppingGivesText() {
  // Title: "Thanks for making an impact!" → "Want to donate more?"
  const titleEl = document.querySelector('#cc-shop-give, .cc-shop-give');
  if (titleEl) {
    titleEl.textContent = 'Want to donate more?';
  }

  // Description under title:
  // "Do you want to give back today? Add a donation of your own to"
  // → "Get a FREE Climate+ Tumbler with every $5 donation to support"
  const descEl = document.querySelector('.sg-text-wrap');
  if (descEl) {
    descEl.textContent = 'Get a FREE Climate+ Tumbler with every $5 donation to support';
  }

  // Hide "Powered by ShoppingGives"
  const logoEl = document.querySelector('.powered-by-logo');
  if (logoEl) {
    logoEl.style.display = 'none';
  }
}
// Run once on initial load (cart drawer present but before interactions)
document.addEventListener('DOMContentLoaded', function () {
  // Give the ShoppingGives script a moment to inject its HTML
  setTimeout(updateShoppingGivesText, 500);
});

// Run every time the cart drawer content updates
document.addEventListener('postCartAction', function () {
  // Cart sections have just been re-rendered; update widget text again
  setTimeout(updateShoppingGivesText, 300);
});
